import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { matchPasswordValidator } from 'src/app/___LOGIC/__auth/match-password.validator';
import { SecurityLayerService } from 'src/app/___LOGIC/__auth/security-layer.service';
import { TranslationService } from 'src/app/___LOGIC/___common/__language/translation.service';
import { TermsPolicyService } from 'src/app/___LOGIC/terms-policy.service';
import { ConfigService } from 'src/app/___LOGIC/___common/__config/config.service';

@Component({
  selector: 'app-register-page',
  templateUrl: './register-page.component.html',
  styleUrls: ['./register-page.component.css']
})
export class RegisterPageComponent implements OnInit {

  signin: FormGroup = new FormGroup({
    email: new FormControl('', [Validators.email, Validators.required ]),
    password: new FormControl('', [Validators.required, Validators.min(8) ]),
    passwordConfirm: new FormControl('', [Validators.required, Validators.min(8) ])},
    { validators: matchPasswordValidator }
  );

  get emailInput() { return this.signin.get('email'); }
  get passwordInput() { return this.signin.get('password'); }
  get passwordConfirmInput() { return this.signin.get('passwordConfirm'); }
  
  hide = true;
  termsAndConditions = false;
  loginObj = {
    path: 'register',
    username: '', 
    token: null,
    password: this.passwordInput.value
  };

  passwordRequirements = {
    minLength: false,
    uppercase: false,
    lowercase: false,
    number: false,
    specialChar: false
  };

  mode;

  preRegistered = false;
  expired = false;
  showEmail = false;
  termsChecked = false;

  constructor(private securityLayer: SecurityLayerService,private route:ActivatedRoute,private translationService: TranslationService,private termsAndPolicyService: TermsPolicyService,private configService: ConfigService) { }

  ngOnInit(): void {
    //Process URL
    if(this.route.snapshot.paramMap.get('token')){
      this.mode = 'validateToken';
      this.loginObj.token = this.route.snapshot.paramMap.get('token');
      this.preRegistered = true;
      this.load();
      this.signin.get('password').valueChanges.subscribe(value => this.onPasswordInput(value));
    }else{
      this.preRegistered = false;
    }
  }

  async load(){
    let url = this.configService.getApiUrlRefactor('auth')+"check_pass_token.php?token="+this.loginObj.token;
    const data = await this.securityLayer.checkToken(url).toPromise();
    this.securityLayer.setIsLoading(false);
    if(data['OK'] && data['OK'].username){
      this.loginObj.username = data['OK'].username;
      this.preRegistered = true;
    }else{
      console.log('Error on token validation');
      this.expired = true;
      //this.guiFlow.openSimpleSnackBar('Enlace expirado','Ok');
    }
  }

  onPasswordInput(password: string): void {
    this.passwordRequirements.minLength = password.length >= 8;
    this.passwordRequirements.uppercase = /[A-Z]/.test(password);
    this.passwordRequirements.lowercase = /[a-z]/.test(password);
    this.passwordRequirements.number = /\d/.test(password);
    this.passwordRequirements.specialChar = /[\W_]/.test(password);
  }

  isLoading(){
    return this.securityLayer.isLoginManagerLoading();
  }

  enableNewLink(){
    this.showEmail = true;
  }

  generateNewLink(){
    this.loginObj.username = this.emailInput.value;
    this.securityLayer.generateNewLink(this.loginObj);
  }


  areFieldsFilled(){
    return (this.passwordConfirmInput.value && this.passwordConfirmInput.value) && this.passwordConfirmInput.value == this.passwordInput.value && this.passwordInput.valid && this.termsChecked;
  }

  firstLogin(){
    // if user is registering for the first time by click Register
    if(!this.preRegistered){
      this.loginObj.username = this.emailInput.value;
    }
    this.loginObj.password = this.passwordInput.value;
    this.securityLayer.saveNewPass(this.loginObj);
  }

  onKeyUp(event: KeyboardEvent){
    if (event.key && event.key === "Enter") {
      this.firstLogin();
    }
  }

  isEmailFilled(){
    return this.emailInput.valid;
  }

  getTranslationFor(label){
    return this.translationService.getTranslatedText(label);
  }

  /* TERMS AND CONDITIONS */
  onTermsChecked(event){
    if(event.checked){
      this.termsChecked = true;
    }
  }

}
